import { Form, Input } from "../../components/ui";
import { AlertTriangle, CloudLightning, HeartPulse, StickyNote, Plus, Trash2 } from "lucide-react";

const SECTIONS = [
  {
    name: "allergies",
    label: "Allergies",
    hint: "Food, medicine, or environmental triggers",
    placeholder: "e.g. Peanuts",
    addLabel: "Add allergy",
    icon: AlertTriangle,
    tone: "is-allergy",
  },
  {
    name: "fears",
    label: "Fears",
    hint: "Situations that cause anxiety",
    placeholder: "e.g. Loud noises",
    addLabel: "Add fear",
    icon: CloudLightning,
    tone: "is-fear",
  },
  {
    name: "conditions",
    label: "Medical Conditions",
    hint: "Ongoing health needs staff should know",
    placeholder: "e.g. Asthma",
    addLabel: "Add condition",
    icon: HeartPulse,
    tone: "is-condition",
  },
  {
    name: "summary",
    label: "Notes",
    hint: "General observations and reminders",
    placeholder: "Short note about the student",
    addLabel: "Add note",
    icon: StickyNote,
    tone: "is-note",
    full: true,
    multiline: true,
  },
];

function HealthPanel({ name, label, hint, placeholder, addLabel, icon: Icon, tone, full, multiline }) {
  return (
    <div className={`ch-panel ${tone}${full ? " is-full" : ""}`}>
      <div className="ch-panel-head">
        <span className="ch-panel-icon">
          <Icon size={18} />
        </span>
        <div>
          <p className="ch-panel-title">{label}</p>
          <p className="ch-panel-hint">{hint}</p>
        </div>
      </div>

      <Form.List name={name}>
        {(fields, { add, remove }) => (
          <div className="ch-panel-body">
            {fields.map((field, index) => (
              <div key={field.key} className="ch-entry-row">
                <span className="ch-entry-index">{index + 1}</span>
                <Form.Item name={[field.name]} className="ch-entry-item">
                  {multiline ? (
                    <Input.TextArea rows={2} placeholder={placeholder} className="ch-entry-input" />
                  ) : (
                    <Input placeholder={placeholder} className="ch-entry-input" />
                  )}
                </Form.Item>
                {fields.length > 1 ? (
                  <button
                    type="button"
                    className="ch-entry-remove"
                    onClick={() => remove(field.name)}
                    aria-label={`Remove ${label.toLowerCase()} ${index + 1}`}
                  >
                    <Trash2 size={15} />
                  </button>
                ) : (
                  <span className="ch-entry-spacer" aria-hidden />
                )}
              </div>
            ))}
            <button type="button" className="ch-entry-add" onClick={() => add("")}>
              <Plus size={15} />
              {addLabel}
            </button>
          </div>
        )}
      </Form.List>
    </div>
  );
}

export default function HealthNotesFields() {
  return (
    <div className="ch-board">
      {SECTIONS.map((section) => (
        <HealthPanel key={section.name} {...section} />
      ))}
    </div>
  );
}

export { SECTIONS };
